import axios from 'axios'
import ApiURL from './ApiUrl'
import cookie from 'react-cookies'
import { notify } from 'react-notify-toast'

// GET ALL CHALLENGES ALBUMS
export const getAllUserWatchedVideos = async (isThispaidFolder) => {
  let allChallengesAlbums

  const getAllWatchedVideosConfig = {
    method: 'get',
    url: `${ApiURL}/api/challenge_albums/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getAllWatchedVideosConfig)
    .then((response) => {
      allChallengesAlbums = response.data
    })
    .catch((error) => {
      console.log(error)
    })

  return allChallengesAlbums
}

export const generateChallengesStripeSession = async (id) => {
  let stripeSession

  const generateChallengesStripeSessionConfig = {
    method: 'post',
    url: `${ApiURL}/api/inappsubscriptions/stripe/challenge_album_session/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      id: id,
    },
  }

  await axios(generateChallengesStripeSessionConfig)
    .then((response) => {
      stripeSession = response.data
    })
    .catch((error) => {
      console.log(error)
    })

  return stripeSession
}

export const getProductData = async (id) => {
  let productData

  const getProductDataConfig = {
    method: 'get',
    url: `${ApiURL}/api/stripe_controller/challenge_album_products/${id}/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getProductDataConfig)
    .then((response) => {
      productData = response.data
    })
    .catch((error) => {
      console.log(error)
    })

  return productData
}

export const getChallengeCategories = async () => {
  let challengeCategories

  const getChallengeCategoriesConfig = {
    method: 'get',
    url: `${ApiURL}/api/stripe_controller/challenge_album_categories/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getChallengeCategoriesConfig)
    .then((response) => {
      challengeCategories = response.data
    })
    .catch((error) => {
      console.log(error)
    })

  return challengeCategories
}

export const setChallengeVideoStatus = async (albumId, videoId, videoOrder) => {
  let createdStatus

  const setChallengeVideoStatusConfig = {
    method: 'post',
    url: `${ApiURL}/api/challenge_video_statuses/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      challenge_album: albumId,
      video_id: videoId,
      video_order: videoOrder,
    },
  }

  await axios(setChallengeVideoStatusConfig)
    .then((response) => {
      createdStatus = response.data
    })
    .catch((error) => {})
  return createdStatus
}

export const setChallengeVideoLocked = async (videoId) => {
  const setChallengeVideoLockedConfig = {
    method: 'patch',
    url: `${ApiURL}/api/challenge_video_statuses/${videoId}/set_as_locked/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(setChallengeVideoLockedConfig)
    .then((response) => {})
    .catch((error) => {
      console.log(error)
    })
}

export const setChallengeVideoWatched = async (videoId) => {
  const setChallengeVideoWatchedConfig = {
    method: 'patch',
    url: `${ApiURL}/api/challenge_video_statuses/${videoId}/set_as_watched/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(setChallengeVideoWatchedConfig)
    .then((response) => {
      notify.show(
        `Gratulujemy! Trening został obejrzany!`,

        'success',
        5000
      )
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getChallengeStatuses = async (statusId, albumId) => {
  let videoStatus

  const getChallengeSatusesConfig = {
    method: 'get',
    url: `${ApiURL}/api/challenge_video_statuses/status_detail/?video_id=${statusId}&album_id=${albumId}`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getChallengeSatusesConfig)
    .then((response) => {
      videoStatus = response
    })
    .catch((error) => {})

  return videoStatus
}

export const getUserChallengeSubs = async () => {
  let challengeSubs

  const getUserChallengeSubsConfig = {
    method: 'get',
    url: `${ApiURL}/api/inappsubscriptions/challenge_album_access/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
  }

  await axios(getUserChallengeSubsConfig)
    .then((response) => {
      challengeSubs = response
    })
    .catch((error) => {
      console.log(error)
    })

  return challengeSubs
}

export const createMiazgaNutshellStripeSession = async (id) => {
  // miazga nutshell id 9569537
  let challengeSubs

  const createMiazgaNutshellStripeSessionConfig = {
    method: 'post',
    url: `${ApiURL}/api/inappsubscriptions/stripe/temporary_challenge_album_session/`,
    headers: {
      Authorization: 'Bearer ' + cookie.load('accessToken'),
    },
    data: {
      album_id: parseInt(id),
    },
  }

  await axios(createMiazgaNutshellStripeSessionConfig)
    .then((response) => {
      challengeSubs = response
    })
    .catch((error) => {
      console.log(error)
    })

  return challengeSubs
}
